/* eslint-disable import/no-anonymous-default-export */
import { RESET_DATA, SET_BRAND_DETAILS_DATA, RESET_FORM_TABLE_DATA, SET_BRAND_EQUIPMENT_DATA, SET_BUILDING_DETAILS, SET_BUILDING_HISTORY, SET_EQUIPMENT_COUNT_DATA, SET_EQUIPMENT_DETAILS, SET_EQUIPMENT_HISTORY, SET_FILTER_BY_DATA, SET_LOADER, SET_REFRIGERANT_TABLE_DATA, SET_REFRIGERANT_TABLE_TOTAL, SET_TABLE_FILTER_OPTION, SET_TABLE_FORM_DATA, SET_TAB_DETAIL, SET_CARD_LOADER, SET_LOADER_TYPE } from "./types";

const initialState = {
  loader: false,
  loaderType: "",
  cardLoader: false,
  tabDetail: { viewTypeKey: "1", viewType: "listView", selectedView: "refrigerant", selectedViewKey: "1" },
  filterBy: { tag: null, value: null, filteredData: {} },
  tableFilter: { selectedAddress: 'country', nextAddress: 'form_state' },
  tableForm: {},
  refrigerantAmountTable: {},
  buildingDetails: {},
  buildingHistory: {},
  equipmentDetails: {},
  equipmentHistory: {},
  equipmentCountData: {},
  equipmentBrandList: {},
  equipmentBrandDetails: {},
}

export default (state = initialState, action) => {
  switch (action.type) {
    case SET_LOADER:
      return {
        ...state,
        loader: action?.payload,
      };

    case SET_LOADER_TYPE:
      return {
        ...state,
        loaderType: action?.payload,
      };

    case SET_CARD_LOADER:
      return {
        ...state,
        cardLoader: action?.payload,
      };

    case SET_TAB_DETAIL:
      return {
        ...state,
        tabDetail: { ...state.tabDetail, ...action?.payload },
      };
    case SET_FILTER_BY_DATA:
      return {
        ...state,
        filterBy: { ...state.filterBy, ...action?.payload },
      };
    case SET_TABLE_FILTER_OPTION:
      return {
        ...state,
        tableFilter: { ...state.tableFilter, ...action?.payload },
      };
    case SET_TABLE_FORM_DATA:
      return {
        ...state,
        tableForm: action?.payload,
      };
    case SET_REFRIGERANT_TABLE_DATA:
      return {
        ...state,
        refrigerantAmountTable: action?.payload,
      };
    case SET_REFRIGERANT_TABLE_TOTAL:
      return {
        ...state,
        refrigerantAmountTotal: action?.payload,
      };
    case SET_BUILDING_DETAILS:
      return {
        ...state,
        buildingDetails: action?.payload,
      };
    case SET_BUILDING_HISTORY:
      return {
        ...state,
        buildingHistory: action?.payload,
      };
    case SET_EQUIPMENT_DETAILS:
      return {
        ...state,
        equipmentDetails: action?.payload,
      };
    case SET_EQUIPMENT_HISTORY:
      return {
        ...state,
        equipmentHistory: action?.payload,
      };
    case SET_EQUIPMENT_COUNT_DATA:
      return {
        ...state,
        equipmentCountData: action?.payload,
      };
    case SET_BRAND_EQUIPMENT_DATA:
      return {
        ...state,
        equipmentBrandList: action?.payload,
      };
    case SET_BRAND_DETAILS_DATA:
      return {
        ...state,
        equipmentBrandDetails: action?.payload,
      };

    case RESET_DATA:
      return initialState

    case RESET_FORM_TABLE_DATA:
      return {
        ...state,
        ...action.payload,
        tableForm: {},
        refrigerantAmountTable: {},
        buildingDetails: {},
        buildingHistory: {},
        equipmentDetails: {},
        equipmentHistory: {},
        equipmentCountData: {},
        equipmentBrandList: {},
        equipmentBrandDetails: {},
        refrigerantAmountTotal: {}
      }

    default:
      return { ...state };
  }
};
